module.exports = __webpack_public_path__ + "img/banner_cen.861b47ce.png";